import { faCalendar, faFile, faFilePdf, faLink, faPhone, faQuestionCircle, faReceipt, faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { formatDateDDMMYYYYHHMM, formatPhone } from "../utils/formats";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import openWhatsApp from "../utils/openWhatsapp";
import BudgetInfoModal from "./BudgetInfoModal";
import PreBudgetModal from "./PreBudgetModal";
import Swal from "sweetalert2";
import Globals from "../Globals";
import AuthorizationIcon from "./AuthorizationIcon";
import api from "../services/api";

export default function AttendancePartialCard({ attendance, refresh }) {
  const [preBudgetModalOpen, setPreBudgetModalOpen] = useState(false);
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);

  const openPreBudgetModal = (attendance) => {
    if (attendance.image_path_pre) {
      Swal.fire({
        title: "O pré-orçamento deste agendamento já foi gerado!",
        text: "Deseja refazê-lo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, refazer",
        cancelButtonText: "Não"
      }).then((result) => {
        if (result.isConfirmed) {
          setPreBudgetModalOpen(true);
          setSelectedPrescription(attendance);
        }
      });
    } else {
      setPreBudgetModalOpen(true);
      setSelectedPrescription(attendance);
    }
  };

  const closePreBudgetModal = () => {
    setPreBudgetModalOpen(false);
    setSelectedPrescription(null);
  };

  const openPdfModal = (attendance) => {
    setSelectedPrescription(attendance);
    setCompleteModalOpen(true);
  };

  const closePdfModal = () => {
    setCompleteModalOpen(false);
    setSelectedPrescription(null);
  };

  const handleModalSave = () => {
    refresh();
  };

  const openPdfFile = (file) => {
    const fileUrl = Globals.BASE_URL + '/storage/' + file;

    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(fileUrl, '_blank');
    }
  }

  const sendWhatsappLink = async (attendance, e) => {
    e.preventDefault();

    const confirmResult = await Swal.fire({
      title: 'Atenção',
      text: 'Deseja enviar o link de autorização para o Whatsapp do paciente?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Aguarde',
      text: 'Gerando o link de autorização...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await api.post('api/consent/send-whatsapp-budget', {
        budget_id: attendance.attendance_id,
        professional_cpf: attendance.professional_cpf,
        professional_name: attendance.professional_name,
        scope: "uso-dados-pessoais"
      });

      Swal.close();

      const message = response.data.data;
      const encodedMessage = encodeURIComponent(message)

      const cleanNumber = attendance.mobile.replace(/\D/g, "")
      window.open(`https://wa.me/55${cleanNumber}?text=${encodedMessage}`, "_blank")

    } catch (error) {
      console.error("Erro ao gerar link do WhatsApp:", error);

      Swal.close();
      Swal.fire({
        title: 'Erro!',
        text: 'Ocorreu um erro ao gerar o link.',
        icon: 'error',
        confirmButtonText: 'Fechar'
      });
    }
  };

  // const sendWhatsappLink = async (attendance, e) => {
  //   e.preventDefault();

  //   // 5 - Incluir swal de erro caso a API retorne erro.
  //   await api.post('api/consent/send-whatsapp-budget', {
  //     budget_id: attendance.attendance_id,
  //     professional_cpf: attendance.professional_cpf,
  //     professional_name: attendance.professional_name,
  //     scope: "uso-dados-pessoais",
  //   }).then(response => {
  //     console.log('response', response)
  //     console.log('data', response.data)

  //     // pegar o retorno desse link e abrir o whatsapp web com a mensagem no numero do paciente 
  //   })
  // }

  return (
    <div>
      <Col>
        <Card className="h-100 primary-border border-hover-success">
          <Card.Body>
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                <Row className="g-2 align-items-center">
                  <Col md={1}>
                    <div
                      className="rounded-circle bg-dark d-flex align-items-center justify-content-center text-white fw-bold"
                      style={{ width: '50px', height: '50px', fontSize: '1.2rem' }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} size="xl" />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faPhone} className="me-3 primary-color" />
                        <span className="fs-5">{formatPhone(attendance.mobile)} {attendance.sms_name && `- ${attendance.sms_name}`}</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faUserDoctor} className="me-3 primary-color" />
                        <span className="fs-5">
                          {
                            attendance.professional_name ? attendance.professional_name : <span className="text-muted">PROFISSIONAL NÃO INFORMADO</span>
                          }
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faCalendar} className="me-3 primary-color" />
                        <span>Data da solicitação: {formatDateDDMMYYYYHHMM(attendance.date_scheduling)}</span>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} className="d-flex justify-content-between align-items-center">
                    <Button
                      onClick={(e) => openWhatsApp(attendance.mobile, e)}
                      style={{ background: "#25D366", borderColor: "#25D366" }}
                      onMouseEnter={(e) => {
                        e.target.style.opacity = '.7';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = '1';
                      }}
                    //disabled={!attendance.sms_status_lgpd}
                    >
                      <FontAwesomeIcon icon={faWhatsapp} size="lg" className="me-2" /> Whatsapp
                    </Button>

                    <Button
                      variant="outline-success"
                      onClick={(e) => sendWhatsappLink(attendance, e)}
                    >
                      <FontAwesomeIcon icon={faLink} size="lg" className="me-2" /> Link Whatsapp
                    </Button>

                    <div className="d-flex gap-5 align-items-center">
                      <Button
                        variant="outline-primary"
                        onClick={() => openPreBudgetModal(attendance)}
                        disabled={!attendance.sms_status_lgpd}
                      >
                        <FontAwesomeIcon icon={faFile} size="lg" className="me-2" /> Pré-orçamento
                      </Button>

                      {
                        attendance.image_path_pre && (
                          <FontAwesomeIcon
                            icon={faReceipt}
                            size="2x"
                            className="me-1 primary-color"
                            title="Abrir arquivo de pré-orçamento"
                            onClick={openPdfFile(attendance.image_path_pre)}
                            style={{ transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                          />
                        )
                      }

                    </div>

                    <Button
                      variant="outline-primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPdfModal(attendance);
                      }}
                      style={{ right: '30%' }}
                      disabled={!attendance.sms_status_lgpd}
                    >
                      <FontAwesomeIcon icon={faFilePdf} />
                      <span>Preencher informações</span>
                    </Button>

                    <AuthorizationIcon
                      id={attendance.attendance_id}
                      professionalCpf={attendance.professional_cpf}
                      professionalName={attendance.professional_name}
                      authorized={attendance.sms_status_lgpd}
                      count={attendance.sms_quantity_send} />
                  </Col>
                </Row>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <PreBudgetModal
        show={preBudgetModalOpen}
        onHide={closePreBudgetModal}
        selectedBudget={selectedPrescription}
        onSave={handleModalSave}
      />

      <BudgetInfoModal
        show={completeModalOpen}
        onHide={closePdfModal}
        selectedBudget={selectedPrescription}
        onSave={handleModalSave}
      />
    </div>
  );
}